<template>
  <div style="height: 100%">
    <table class="table-head" cellpadding="0" cellspacing="0">
      <tr ref="tableTr">
        <th class="label" v-for="item in headList" :key="item.label" :width="item.width">{{ item.label }}</th>
      </tr>
    </table>
    <div class="scroll-y">
      <table class="table-content" cellpadding="0" cellspacing="0">
        <tr v-for="(item, i) in tableData" :key="item.id">
          <td class="val" width="100">{{ i + 1 }}</td>
          <td class="val" width="100">{{ item.town | filterTown }}</td>
          <td class="val" width="100">{{ item.deviceName }}</td>
          <td class="val" width="100" :class="item.status === 1 ? 'font-00FFF6' : 'font-FF1C2F'">{{ item.status === 1 ? '在线' : '离线' }}</td>
          <td class="val" width="100">{{ item.deviceSerial }}</td>
          <td class="val font-00FFF6" width="100">{{ (item.latitude || '') + ' '  + (item.longitude || '') }}</td>
          <td class="val" width="100">
            <el-image
              v-if="item.image"
              style="width: 60px; height: 60px"
              :src="baserUrl + item.image"
              :preview-src-list="[baserUrl + item.image]"
              fit="fill"></el-image>
          </td>
          <td class="val" width="60">
            <span class="link" @click="openEdit(item)">编辑</span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { baserUrl } from "../../../../plugins/BsaeUrl";
import { townshipList } from "../../../../utils/common";
export default {
  name: "Table",
  props: {
    tableData: { type: Array, default: () => [] }
  },
  data () {
    return {
      baserUrl: baserUrl,
      headList: [
        {label: '序号', width: '100'},
        {label: '所属乡镇', width: '100'},
        {label: '设备名称', width: '100'},
        {label: '状态', width: '100'},
        {label: '设备序列号', width: '100'},
        {label: '经纬度', width: '100'},
        {label: '点位照片', width: '100'},
        {label: '操作', width: '60'},
      ]
    }
  },
  filters: {
    filterTown (val) {
      const list = townshipList.filter(x => {
        return x.value === val
      })
      return list[0] ? list[0].label : '-'
    }
  },
  methods: {
    openEdit (item) {
      this.$emit('openEdit', item)
    }
  }
}
</script>

<style scoped lang="less">
.table-head {
  width: 100%;
  height: 50px;
  background-color: rgba(0, 255, 246, 0.3);

  th {
    padding: 0 10px;
    color: #00FFF6;
    font-size: 18px;
  }
}

.link{
  cursor: pointer;
}
.scroll-y {
  height: calc(100% - 50px);
  overflow-y: auto;
}

.table-content {
  width: 100%;
  text-align: center;
  table-layout: fixed;
  tr {
    height: 50px;
  }

  tr:nth-child(even) {
    background-color: rgba(0, 255, 246, 0.1);
  }

  td {
    padding: 0 10px;
    font-size: 16px;
    height: 50px;
  }
}
</style>
